// Phone number utility — the number is stored base64-encoded so it is NOT
// present in the raw HTML source. It is decoded at render time in the browser.
// This defeats the vast majority of scraper bots that harvest phone numbers
// from public web pages by regex-matching the static markup.
//
// Real users see the number exactly as before; tel: links continue to work.
// (Note: this is obfuscation, not encryption — a determined scraper that
// runs JS can still find it. This trade-off is intentional to keep the UX
// zero-friction.)

const P_ENCODED = 'NTA0MjM2NzQ3OQ=='; // base64 of "5042367479"

const decodeRaw = () => {
  if (typeof window === 'undefined' || typeof window.atob !== 'function') {
    return '';
  }
  try {
    return window.atob(P_ENCODED);
  } catch {
    return '';
  }
};

// Returns "504-236-7479" (formatted for display)
export const getPhoneDisplay = () => {
  const raw = decodeRaw();
  if (raw.length !== 10) return '';
  return `${raw.slice(0, 3)}-${raw.slice(3, 6)}-${raw.slice(6)}`;
};

// Returns "tel:5042367479" for anchor href
export const getPhoneTel = () => {
  const raw = decodeRaw();
  return raw ? `tel:${raw}` : '#';
};
